export const container = '';
export const bannerContent = 'px-4 z-10';
export const wrapper = 'w-full flex justify-center mt-4 mb-4 md:mb-0';
